/* tslint:disable */
/* eslint-disable */
/**
 * Auth Service API
 * Auth Service API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MyPermissionsDto interface.
 */
export function instanceOfMyPermissionsDto(value) {
    if (!('rolesByLocation' in value) || value['rolesByLocation'] === undefined)
        return false;
    if (!('permissionsByRole' in value) || value['permissionsByRole'] === undefined)
        return false;
    if (!('permissionsById' in value) || value['permissionsById'] === undefined)
        return false;
    return true;
}
export function MyPermissionsDtoFromJSON(json) {
    return MyPermissionsDtoFromJSONTyped(json, false);
}
export function MyPermissionsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'rolesByLocation': json['rolesByLocation'],
        'permissionsByRole': json['permissionsByRole'],
        'permissionsById': json['permissionsById'],
    };
}
export function MyPermissionsDtoToJSON(json) {
    return MyPermissionsDtoToJSONTyped(json, false);
}
export function MyPermissionsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'rolesByLocation': value['rolesByLocation'],
        'permissionsByRole': value['permissionsByRole'],
        'permissionsById': value['permissionsById'],
    };
}
//# sourceMappingURL=MyPermissionsDto.js.map